module.exports = __webpack_public_path__ + "static/img/top_button.def8bdd2.png";